import { Content } from '@wajeez-web/core/api-base';
import {
  CreateBusinessGroupMultilingual,
  useBusinessSelector,
} from '@wajeez-web/stores/business-group';
import { useTranslation } from 'react-i18next';
import { WajeezMultilingualFormBuilder } from '@wajeez-web/components/form-builder';
import { Skeleton } from 'antd';
import { Languages } from '@wajeez-web/core/utils';

export interface BusinessBasicInfoProps {
  onSubmit: (data: CreateBusinessGroupMultilingual) => void;
}

const BusinessBasicInfo = ({ onSubmit }: BusinessBasicInfoProps) => {
  const { t } = useTranslation();
  const { editMultilingual, detailsMultilingual, createMultiligual } =
    useBusinessSelector((state) => state.businessGroups);

  const data = detailsMultilingual.data;
  const loading = detailsMultilingual.status === 'loading';

  return (
    <div className=" ">
      {loading ? (
        <Skeleton active />
      ) : (
        <div className="w-[80%] pb-[150px]">
          <WajeezMultilingualFormBuilder<CreateBusinessGroupMultilingual>
            isLoading={loading}
            hasToggleButton={true}
            onSubmit={onSubmit}
            title={t(`general.${'Basic Info'}`, '') as string}
            formValues={
              !data
                ? {
                  profiles: [{ languageId: Languages.AR }],
                  welcomeEmailTemplateId: 26
                }
                : !data.profiles.length
                  ? { ...data, profiles: [{ languageId: Languages.AR }] }
                  : data
            }
            isUpdate={
              editMultilingual.status === 'loading' ||
              createMultiligual.status === 'loading'
            }
            profileRows={{
              welcomeText: {
                order: 100,
                label: 'Welcome Text',
                placeHolder: 'Enter Welcome Text',
                required: true,
                fieldType: Content.FieldType.Text,
                fieldOptions: {},
              },
            }}
            rows={{
              isDemo: {
                order: 0,
                label: 'Is Demo',
                placeHolder: 'Select Is Demo',
                required: true,
                fieldType: Content.FieldType.Switch,
                fieldOptions: {},
              },
              prefix: {
                order: 50,
                label: 'Prefix',
                placeHolder: 'Enter Prefix',
                required: true,
                fieldType: Content.FieldType.Text,
                fieldOptions: {},
              },
              name: {
                order: 100,
                label: 'Name',
                placeHolder: 'Enter Name',
                required: true,
                fieldType: Content.FieldType.Text,
                fieldOptions: {},
              },
              phoneNumber: {
                order: 100,
                label: 'Phone Number',
                placeHolder: 'Ex: +96279*******',
                required: false,
                fieldType: 0,
                fieldOptions: {},
              },
              address: {
                order: 100,
                label: 'Address',
                placeHolder: 'Enter address',
                required: false,
                fieldType: Content.FieldType.Text,
                fieldOptions: {},
              },
              email: {
                order: 100,
                label: 'Email',
                placeHolder: 'Ex: user@gmail.com',

                required: false,
                fieldType: Content.FieldType.Text,
                fieldOptions: {},
              },
              logoReference: {
                order: 100,
                label: 'Logo',
                placeHolder: 'Please Select Image ',
                required: true,
                fieldType: Content.FieldType.UploadImage,
                fieldOptions: {},
              },
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              themeColor: {
                order: 100,
                label: 'Theme Color',
                placeHolder: 'Please Select A Theme ',
                required: true,
                fieldType: Content.FieldType.ColorPicker,

                fieldOptions: {
                  colors: [
                    '#4CAF50',
                    '#FF9800',
                    '#F44336',
                    '#E91E63',
                    '#B027A4',
                    '#0B6AA7',
                    '#5D4037',
                    '#000000',
                    '#565656',
                    '#008CA2',
                    '#6A20C2',
                    '#00ADE2',
                  ],
                  // pickerType: 'Twitter'
                  pickerType: 'Twitter',
                },
              },
              annualGoal: {
                order: 100,
                label: 'Annual Goal',
                required: true,
                fieldType: Content.FieldType.Number,
                fieldOptions: {},
              },
            }}
          />
        </div>
      )}
    </div>
  );
};

export default BusinessBasicInfo;
